import React, {Component} from 'react';
import newsIllustration from '../../assets/images/news-illustration.png';
import heroBg from '../../assets/images/hero.jpg';
import CONSTANTS from "../../config/constants";
import _ from "lodash";

class HeroSmall extends Component {
    getContentFieldValue = (fieldDefinitionKey) => {
        const {contentFields} = this.props;
        const data = _.find(contentFields, {fieldDefinitionKey: fieldDefinitionKey});

        if (data) {
            try {
                return JSON.parse(data.data);
            } catch (e) {
                return data.data;
            }
        }
        return false
    };

    getBlockWidth = () => {
        const {width} = this.props;

        let w = 100;

        if (width && width !== CONSTANTS.BLOCK_DEFAULT_WIDTH) {
            return width;
        } else {
            if (this.getContentFieldValue('Width') && this.getContentFieldValue('Width') !== CONSTANTS.BLOCK_DEFAULT_WIDTH && this.getContentFieldValue('Width') !== w) {
                w = this.getContentFieldValue('Width');
            }
        }

        return w;
    };

    render() {
        const {item} = this.props;

        const title = (item && item.data && item.data.title) || '';
        let background;
        const foreground = (item && item.data && item.data.image && item.data.image.mediaUrl) || newsIllustration;

        if (item) {
            if (!item.data.background) {
                background = heroBg;
            } else {
                background = item.data.background;
            }
        } else {
            background = heroBg;
        }

        return (
            <section className="component hero small" style={{backgroundImage: `${background ? `url(${background})` : 'none'}`}}>
                <section className="hero--inner">
                    <h1>{title}</h1>
                </section>
                <img src={foreground} alt={title}/>
            </section>
        );
    }
}

export default HeroSmall;



// WEBPACK FOOTER //
// ./src/frontend/components/Fields/HeroSmall.js